<template>
  <b-container>
    <b-overlay
      :show="loading"
      rounded
      opacity="0.6"
      spinner-large
      spinner-variant="info"
      class="d-inline-block w-100"
      @hidden="!loading"
    >
      <b-row>
        <b-col class="m-3">
          <b-card class="w-100 shadow" :title="(isAdd) ? 'ایجاد سطح دسترسی' : 'ویرایش سطح دسترسی'">
            <b-row>
              <b-col md="12">
                <label for="input_slog" class="text-right w-100 mt-3 required-label">نام</label>
                <b-form-input type="text" v-model="group.slog" id="input_slog" placeholder="ورود نام سطح دسترسی" class="rtl"></b-form-input>
              </b-col>
              <b-col md="12">
                <label for="input_name" class="text-right w-100 mt-3 required-label">کلید</label>
                <b-form-input type="text" v-model="group.name" id="input_name" placeholder="ورود کلید سطح دسترسی به انگلیسی"></b-form-input>
              </b-col>
            </b-row>

            <b-button variant="info" class="mx-auto w-25 mt-5" @click="doAddOrEdit" :disabled="loading">
              <span v-if="isAdd">ایجاد</span>
              <span v-else>ثبت</span>
            </b-button>
            <b-button variant="outline-info" class="mx-auto mt-5" @click="$router.go(homeIndex)" :disabled="loading">
              بازگشت
            </b-button>
          </b-card>
          <b-card class="w-100 shadow text-right mt-3">
            <b-row>
              <b-col md="12">
                <b-table striped hover :items="panelMenuItemTable.items" :fields="panelMenuItemTable.fields" 
                  id="table_panelMenuItem" :busy="panelMenuItemTable.loading" caption-top>
                  <template #table-caption>لیست منو های پنل</template>
                  <template #table-busy>
                    <div class="text-center text-info my-2">
                      در حال دریافت اطلاعات
                      <b-spinner class="align-middle m-1" small></b-spinner>
                    </div>
                  </template>
                  <template #cell(actions)="row">
                    <b-button v-if="panelMenuItemTable.items[row.index].granted" variant="danger" size="sm" @click="removePanelMenuItem(row)"><b-icon icon="trash" class="m-1"></b-icon>حذف مجوز</b-button>
                    <b-button v-else variant="success" size="sm" @click="addPanelMenuItem(row)"><b-icon icon="plus" class="m-1"></b-icon>اعطای مجوز</b-button>
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <!-- <b-row class="justify-content-end mt-5">
              <b-button pill :variant="(true) ? 'info' : 'outline-info'" class="m-1">انتخاب همه مجوز ها</b-button>
              <b-button pill :variant="(false) ? 'info' : 'outline-info'" class="m-1">انتخاب مجوز های عمومی</b-button>
              <b-button pill :variant="(false) ? 'info' : 'outline-info'" class="m-1">انتخاب مجوز های اپراتور</b-button>
              <b-button pill :variant="(false) ? 'info' : 'outline-info'" class="m-1">انتخاب مجوز های ادمین</b-button>
            </b-row> -->
            <b-row>
              <b-col md="12">
                <b-table striped hover :items="permissionTable.items" :fields="permissionTable.fields" 
                  id="table_permission" :busy="permissionTable.loading" caption-top>
                  <template #table-caption>لیست مجوز ها</template>
                  <template #table-busy>
                    <div class="text-center text-info my-2">
                      در حال دریافت اطلاعات
                      <b-spinner class="align-middle m-1" small></b-spinner>
                    </div>
                  </template>
                  <template #cell(actions)="row">
                    <b-button v-if="row.item.granted" variant="danger" size="sm" @click="dropPermission(row)"><b-icon icon="trash" class="m-1"></b-icon>حذف مجوز</b-button>
                    <b-button v-else variant="success" size="sm" @click="grantPermission(row)"><b-icon icon="plus" class="m-1"></b-icon>اعطای مجوز</b-button>
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <b-pagination
              v-show="permissionTable.pagination.count != 0"
              v-model="permissionTable.pagination.page"
              :total-rows="permissionTable.pagination.count"
              :per-page="permissionTable.pagination.limit"
              class="mt-3"
              align="center"
              aria-controls="table_permission"
              @page-click="clickOnPage"
            ></b-pagination>
          </b-card>
        </b-col>
        <b-col class="mx-3 mb-5" md="12">
          <b-button variant="info" class="mx-auto w-25 mt-5" @click="doAddOrEdit" :disabled="loading">
            <span v-if="isAdd">ایجاد</span>
            <span v-else>ثبت</span>
          </b-button>
          <b-button variant="outline-info" class="mx-auto mt-5" @click="$router.go(homeIndex)" :disabled="loading">
            بازگشت
          </b-button>
        </b-col>
      </b-row>
    </b-overlay>
  </b-container>
</template>
<script>
import _ from 'lodash'

export default {
  name: 'AccessLevelAddEdit',
  data: () => ({
    loading: false,
    isAdd: true,
    group_id: null,
    homeIndex: -1,
    group: {
      name: '',
      slog: '',
      panel_menu_items: new Set(),
      permissions: new Set(),
    },
    panelMenuItemTable: {
      fields: [
        {
          key: "key",
          label: "کلید"
        },
        {
          key: "name",
          label: "نام"
        },
        {
          key: "actions",
          label: "عملیات"
        }
      ].reverse(),
      items: [],
      loading: false,
    },
    permissionTable: {
      fields: [
        {
          key: "description",
          label: "توضیحات"
        },
        {
          key: "api_endpoint",
          label: "سرویس"
        },
        {
          key: "action",
          label: "روش"
        },
        {
          key: "actions",
          label: "عملیات"
        }
      ].reverse(),
      items: [],
      pagination: {
        count: 0,
        page: 1,
        limit: 20
      },
      loading: false,
    },
    // permissionSelection: {
    //   all: false,
    //   admin: false,
    //   operator: false,
    //   public: false
    // }
  }),
  created() {
    if (this.$route.query.home_index) {
      this.homeIndex = parseInt(this.$route.query.home_index)
    }

    this.group_id = this.$route.params.group_id

    this.fetchPanelMenuItemsData()

    setTimeout(() => {
      this.fetchPermissions()
    }, 500)

    if (this.group_id) {
      this.isAdd = false

      this.loading = true
      this.$axios.get('/privacy/groups/'+this.group_id).then((response) => {
        const body = response.data

        this.group = _.pick(body.data, ['name', 'slog'])
        this.group.panel_menu_items = new Set(body.data.panel_menu_items)
        this.group.permissions = new Set(body.data.permissions)
      }).catch((err) => {
        this.$bvToast.toast(err.text, { variant: 'danger', title: 'خطا' })
      }).finally(() => {
        this.loading = false
      })
    } 
  },
  methods: {
    fetchPanelMenuItemsData() {
      this.panelMenuItemTable.loading = true

      let params = {}
      if (this.group_id) {
        params["check_group_id"] = this.group_id
      }

      this.$axios.get('/privacy/groups/panel-menu-items', {
        params
      }).then((response) => {
        const body = response.data
        
        this.panelMenuItemTable.items = body.data
      }).catch((err) => {
        this.$bvToast.toast(err.text, { variant: 'danger', title: 'خطا' })
      }).finally(() => {
        this.panelMenuItemTable.loading = false
      })
    },
    fetchPermissions() {
      this.permissionTable.loading = true
      let params = {
        limit: this.permissionTable.pagination.limit,
        page: this.permissionTable.pagination.page
      }
      if (this.group_id) {
        params["check_group_id"] = this.group_id
      }
      this.$axios.get('/privacy/permissions', {
        params
      }).then((response) => {
        const body = response.data

        this.permissionTable.items = body.data

        this.permissionTable.pagination.count = body.count
      }).catch((err) => {
        this.$bvToast.toast(err.text, { variant: 'danger', title: 'خطا' })
      }).finally(() => {
        this.permissionTable.loading = false
      })
    },
    clickOnPage(bvEvent, page) {
      bvEvent.preventDefault()
      this.permissionTable.pagination.page = page
      this.fetchPermissions()
    },
    removePanelMenuItem(row) {
      this.group.panel_menu_items.delete(row.item.key)
      row.item.granted = false
      this.$root.$emit('bv::refresh::table', 'table_panelMenuItem')
    },
    addPanelMenuItem(row) {
      this.group.panel_menu_items.add(row.item.key)
      row.item.granted = true
      this.$root.$emit('bv::refresh::table', 'table_panelMenuItem')
    },
    dropPermission(row) {
      this.group.permissions.delete(row.item._id)
      row.item.granted = false
      this.$root.$emit('bv::refresh::table', 'table_permission')
    },
    grantPermission(row) {
      this.group.permissions.add(row.item._id)
      row.item.granted = true
      this.$root.$emit('bv::refresh::table', 'table_permission')
    },
    doAddOrEdit() {
      if (this.group.slog == "" || !this.group.slog) {
        return this.$bvToast.toast('فیلد نام الزامی است', { variant: 'danger', title: 'خطا' })
      }

      if (this.group.name == "" || !this.group.name) {
        return this.$bvToast.toast('فیلد کلید الزامی است', { variant: 'danger', title: 'خطا' })
      }

      // convert sets to normal array
      this.group.panel_menu_items = [...this.group.panel_menu_items]
      this.group.permissions = [...this.group.permissions]

      this.loading = true
      if (this.isAdd) {
        this.$axios.post('/privacy/groups', this.group).then((response) => {
          if (response.status == 208) { //means duplicate content
            const body = response.data
            this.$bvToast.toast(
              'سطح دسترسی فوق تکراری است، می توانید آن را ویرایش کنید',
              { variant: 'warning', title: 'هورا', href: this.$router.resolve({ name: 'EditDocument', params: { document_id: body.data._id }, query: { home_index: -2 }}).href }
            )
          } else {
            this.$bvToast.toast('سطح دسترسی با موفقیت ایجاد شد', { variant: 'success', title: 'هورا' })
            this.$router.go(this.homeIndex)
          }
        }).catch(err => {
          this.$bvToast.toast(err.text, { variant: 'danger', title: 'خطا' })
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.$axios.put('/privacy/groups/'+this.group_id, this.group).then((response) => {
          if (response.status == 208) { //means duplicate content
            const body = response.data
            this.$bvToast.toast(
              'سطح دسترسی فوق تکراری است، می توانید آن را ویرایش کنید',
              { variant: 'warning', title: 'توجه', href: this.$router.resolve({ name: 'EditDocument', params: { document_id: body.data._id }, query: { home_index: -2 }}).href }
            )
          } else {
            this.$bvToast.toast('سطح دسترسی با موفقیت ویرایش شد', { variant: 'success', title: 'هورا' })
            this.$router.go(this.homeIndex)
          }
        }).catch(err => {
          this.$bvToast.toast(err.text, { variant: 'danger', title: 'خطا' })
        }).finally(() => {
          this.loading = false
        })
      }
    }
  }
}
</script>